// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Have mercy upon us, O Lord, have mercy upon us,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for we have had more than enough of contempt.<br> </p> </div></div>";
// Exports
module.exports = code;